/**
 * Centralized user title constants matching the registration form options.
 * Used for role-based feature gating and the registration dropdown.
 * @module
 */

export const USER_TITLES = {
  ANALYTICS: "Analytics",
  COACHING: "Coaching",
  EXECUTIVE: "Executive",
  OWNERSHIP: "Ownership",
  PERFORMANCE: "Performance",
  SCOUTING: "Scouting",
} as const;

/** Union type of all valid user title strings. */
export type UserTitle = (typeof USER_TITLES)[keyof typeof USER_TITLES];

/** Dropdown options derived from USER_TITLES for use in form selects. */
export const USER_TITLE_OPTIONS: { label: string; value: string }[] =
  Object.values(USER_TITLES).map(title => ({ label: title, value: title }));
